import React from 'react';

// The two animated figures of the Inspect landing page: the hero story (the app saves a Daily Pre-Start,
// it is graded Pass, a Pass row appears in the dashboard's History tab) and the crews story (scan the
// slate, tap the inspection, fill it in and save). Drawn from the mockup's cartoon kit; every word goes
// through t, every direct child is aria-hidden and the figure carries the text as its aria-label.
// props: t, waiting (adds inspect-landing-wait until the figure scrolls into view), figureRef (callback ref).

export function HeroArt(props) {
  var t = props.t;
  return (
    <div
      className={
        'inspect-landing-figure inspect-landing-k-show inspect-landing-hero-art' +
        (props.waiting ? ' inspect-landing-wait' : '')
      }
      ref={props.figureRef}
      role="img"
      aria-label={t('inspectLanding:heroArtLabel')}
    >
      <div className="inspect-landing-k-hist" aria-hidden="true">
        <div className="inspect-landing-k-tabs">
          <span className="inspect-landing-k-tab">
            <span className="material-symbols-outlined">monitoring</span>
            <span className="inspect-landing-k-b" style={{ width: 34 }} />
          </span>
          <span className="inspect-landing-k-tab inspect-landing-k-tab-on">
            <span className="material-symbols-outlined">history</span>
            {t('inspectLanding:artHistory')}
          </span>
          <span className="inspect-landing-k-tab">
            <span className="material-symbols-outlined">calendar_month</span>
            <span className="inspect-landing-k-b" style={{ width: 34 }} />
          </span>
        </div>
        <div className="inspect-landing-k-grid inspect-landing-k-th">
          <span className="inspect-landing-k-hb" style={{ width: '62%' }} />
          <span className="inspect-landing-k-hb" style={{ width: '56%' }} />
          <span className="inspect-landing-k-hb" style={{ width: '48%' }} />
        </div>
        <div className="inspect-landing-k-new">
          <div className="inspect-landing-k-grid inspect-landing-k-tr">
            <span style={{ fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {t('inspectLanding:artForklift')}
            </span>
            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {t('inspectLanding:artDailyPreStart')}
            </span>
            <span>
              <span className="inspect-result-badge pass">{t('inspectLanding:chipPass')}</span>
            </span>
          </div>
        </div>
        <div className="inspect-landing-k-grid inspect-landing-k-tr inspect-landing-k-alt">
          <span className="inspect-landing-k-b" style={{ width: '64%' }} />
          <span className="inspect-landing-k-b" style={{ width: '80%' }} />
          <span>
            <span className="inspect-result-badge fail">{t('inspectLanding:chipFail')}</span>
          </span>
        </div>
        <div className="inspect-landing-k-grid inspect-landing-k-tr">
          <span className="inspect-landing-k-b" style={{ width: '72%' }} />
          <span className="inspect-landing-k-b" style={{ width: '66%' }} />
          <span>
            <span className="inspect-result-badge pass">{t('inspectLanding:chipCorrected')}</span>
          </span>
        </div>
        <div className="inspect-landing-k-grid inspect-landing-k-tr inspect-landing-k-alt">
          <span className="inspect-landing-k-b" style={{ width: '58%' }} />
          <span className="inspect-landing-k-b" style={{ width: '84%' }} />
          <span>
            <span className="inspect-result-badge pass">{t('inspectLanding:chipPass')}</span>
          </span>
        </div>
        <div className="inspect-landing-k-grid inspect-landing-k-tr">
          <span className="inspect-landing-k-b" style={{ width: '68%' }} />
          <span className="inspect-landing-k-b" style={{ width: '72%' }} />
          <span>
            <span className="inspect-result-badge incomplete">
              {t('inspectLanding:chipIncomplete')}
            </span>
          </span>
        </div>
        <div className="inspect-landing-k-grid inspect-landing-k-tr inspect-landing-k-alt">
          <span className="inspect-landing-k-b" style={{ width: '62%' }} />
          <span className="inspect-landing-k-b" style={{ width: '76%' }} />
          <span>
            <span className="inspect-result-badge pass">{t('inspectLanding:chipPass')}</span>
          </span>
        </div>
      </div>
      <div className="inspect-landing-k-phone" aria-hidden="true">
        <div className="inspect-landing-k-scr">
          <div className="inspect-landing-k-shead">
            <span className="material-symbols-outlined">assignment</span>
            <span className="inspect-landing-k-stitle">
              {t('inspectLanding:artDailyPreStart')}
            </span>
            <span className="inspect-landing-k-sdone" />
          </div>
          <div className="inspect-landing-k-sbody">
            <div className="inspect-landing-k-sstat">
              <div className="inspect-landing-k-stat-h">
                <span className="material-symbols-outlined">checklist</span>
                {t('inspectLanding:artInspection')}
              </div>
              <div className="inspect-landing-k-stat-c">
                <span style={{ flex: '1 1 auto', minWidth: 0, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 6 }}>
                  <span className="inspect-landing-ac inspect-landing-ac-pass">
                    {t('inspectLanding:chipPass')}
                  </span>
                  <span className="inspect-landing-k-by">
                    <span className="inspect-landing-k-av" style={{ flexBasis: 10, width: 10, height: 10 }} />
                    <span className="inspect-landing-k-bar-d" style={{ width: 84, height: 5 }} />
                  </span>
                </span>
                <span className="material-symbols-outlined">chevron_right</span>
              </div>
            </div>
            <span className="inspect-landing-k-sgroup" />
            <div className="inspect-landing-k-scard">
              <div className="inspect-landing-k-srow">
                <span className="inspect-landing-k-ico" />
                <span className="inspect-landing-k-lab" style={{ width: 96 }} />
                <span className="inspect-landing-k-valswap">
                  <span className="inspect-landing-k-slider inspect-landing-k-ss">
                    <span className="inspect-landing-k-thumb inspect-landing-k-t1" />
                  </span>
                  <span className="inspect-landing-k-val inspect-landing-k-yes inspect-landing-k-sp" />
                </span>
              </div>
              <div className="inspect-landing-k-srow">
                <span className="inspect-landing-k-ico" />
                <span className="inspect-landing-k-lab" style={{ width: 74 }} />
                <span className="inspect-landing-k-valswap">
                  <span className="inspect-landing-k-slider inspect-landing-k-ss">
                    <span className="inspect-landing-k-thumb inspect-landing-k-t2" />
                  </span>
                  <span className="inspect-landing-k-val inspect-landing-k-yes inspect-landing-k-sp" />
                </span>
              </div>
              <div className="inspect-landing-k-srow">
                <span className="inspect-landing-k-ico" />
                <span className="inspect-landing-k-lab" style={{ width: 88 }} />
                <span className="inspect-landing-k-valswap">
                  <span className="inspect-landing-k-slider inspect-landing-k-ss">
                    <span className="inspect-landing-k-thumb inspect-landing-k-t3" />
                  </span>
                  <span className="inspect-landing-k-val inspect-landing-k-yes inspect-landing-k-sp" />
                </span>
              </div>
              <div className="inspect-landing-k-srow">
                <span className="inspect-landing-k-ico" />
                <span className="inspect-landing-k-lab" style={{ width: 64 }} />
                <span className="inspect-landing-k-valswap">
                  <span className="inspect-landing-k-slider inspect-landing-k-ss">
                    <span className="inspect-landing-k-thumb inspect-landing-k-t4" />
                  </span>
                  <span className="inspect-landing-k-val inspect-landing-k-yes inspect-landing-k-sp" />
                </span>
              </div>
            </div>
            <div className="inspect-landing-k-sfoot">
              <div className="inspect-landing-k-ssave">
                <span className="material-symbols-outlined inspect-landing-fill">save</span>
                {t('inspectLanding:artSaveEntry')}
                <span className="inspect-landing-k-tapring" />
              </div>
              <div className="inspect-landing-k-ssaved">
                <span className="material-symbols-outlined">check_circle</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function CrewArt(props) {
  var t = props.t;
  return (
    <div
      className={
        'inspect-landing-figure inspect-landing-crew-art' +
        (props.waiting ? ' inspect-landing-wait' : '')
      }
      ref={props.figureRef}
      role="img"
      aria-label={t('inspectLanding:crewArtLabel')}
    >
      <div className="inspect-landing-k-phone" aria-hidden="true">
        <div className="inspect-landing-k-scr">
          <div className="inspect-landing-c7-slate">
            <div className="inspect-landing-c7-bar">
              <span className="material-symbols-outlined">arrow_back</span>
              <span className="inspect-landing-c7-bar-t">{t('inspectLanding:artForklift')}</span>
              <span className="material-symbols-outlined inspect-landing-fill">settings</span>
            </div>
            <span className="inspect-landing-c7-gbar" style={{ top: 58, width: 64 }} />
            <div className="inspect-landing-c7-card" style={{ top: 74 }}>
              <div className="inspect-landing-c7-f">
                <span className="inspect-landing-k-ico" />
                <span className="inspect-landing-k-lab" style={{ width: 58 }} />
                <span className="inspect-landing-c7-v" style={{ width: 82 }} />
              </div>
              <div className="inspect-landing-c7-rec">
                <span className="material-symbols-outlined inspect-landing-c7-rec-i">
                  assignment
                </span>
                <span className="inspect-landing-c7-rec-h">
                  <span className="inspect-landing-c7-rec-t">
                    {t('inspectLanding:artDailyPreStart')}
                  </span>
                  <span className="inspect-landing-c7-count">
                    {t('inspectLanding:artCount')}
                    <span className="material-symbols-outlined">arrow_forward_ios</span>
                  </span>
                </span>
                <span className="inspect-landing-c7-add">
                  <span className="material-symbols-outlined">add</span>
                  {t('inspectLanding:artDailyPreStart')}
                  <span className="inspect-landing-c7-tapring inspect-landing-c7-tap-b" />
                </span>
                <span className="inspect-landing-c7-last">
                  <span className="inspect-landing-k-av" />
                  <span className="inspect-landing-c7-name" />
                  <span className="inspect-landing-c7-when">
                    <span className="inspect-landing-c7-old">
                      {t('inspectLanding:artDayAgo')}
                    </span>
                    <span className="inspect-landing-c7-new">
                      {t('inspectLanding:artMomentAgo')}
                    </span>
                  </span>
                </span>
              </div>
              <div className="inspect-landing-c7-f">
                <span className="inspect-landing-k-ico" />
                <span className="inspect-landing-k-lab" style={{ width: 70 }} />
                <span className="inspect-landing-c7-v" style={{ width: 64 }} />
              </div>
            </div>
            <span className="inspect-landing-c7-gbar" style={{ top: 268, width: 52 }} />
            <div className="inspect-landing-c7-card" style={{ top: 284 }}>
              <div className="inspect-landing-c7-f">
                <span className="inspect-landing-k-ico" />
                <span className="inspect-landing-k-lab" style={{ width: 76 }} />
                <span className="inspect-landing-c7-v" style={{ width: 70 }} />
              </div>
              <div className="inspect-landing-c7-f">
                <span className="inspect-landing-k-ico" />
                <span className="inspect-landing-k-lab" style={{ width: 62 }} />
                <span className="inspect-landing-c7-v" style={{ width: 90 }} />
              </div>
            </div>
          </div>
          <div className="inspect-landing-c7-sheet">
            <div className="inspect-landing-k-shead">
              <span className="material-symbols-outlined">assignment</span>
              <span className="inspect-landing-k-stitle">
                {t('inspectLanding:artDailyPreStart')}
              </span>
              <span className="inspect-landing-k-sdone" />
            </div>
            <div className="inspect-landing-c7-sbody">
              <span className="inspect-landing-c7-gbar" style={{ top: 14, width: 92 }} />
              <div className="inspect-landing-c7-card" style={{ top: 30 }}>
                <div className="inspect-landing-k-srow">
                  <span className="inspect-landing-k-ico" />
                  <span className="inspect-landing-k-lab" style={{ width: 96 }} />
                  <span className="inspect-landing-k-slider">
                    <span className="inspect-landing-k-thumb inspect-landing-c7-t1" />
                  </span>
                </div>
                <div className="inspect-landing-k-srow">
                  <span className="inspect-landing-k-ico" />
                  <span className="inspect-landing-k-lab" style={{ width: 74 }} />
                  <span className="inspect-landing-k-slider">
                    <span className="inspect-landing-k-thumb inspect-landing-c7-t2" />
                  </span>
                </div>
                <div className="inspect-landing-k-srow">
                  <span className="inspect-landing-k-ico" />
                  <span className="inspect-landing-k-lab" style={{ width: 88 }} />
                  <span className="inspect-landing-k-slider">
                    <span className="inspect-landing-k-thumb inspect-landing-c7-t3" />
                  </span>
                </div>
                <div className="inspect-landing-k-srow">
                  <span className="inspect-landing-k-ico" />
                  <span className="inspect-landing-k-lab" style={{ width: 64 }} />
                  <span className="inspect-landing-k-slider">
                    <span className="inspect-landing-k-thumb inspect-landing-c7-t4" />
                  </span>
                </div>
              </div>
              <div className="inspect-landing-c7-foot">
                <div className="inspect-landing-c7-save">
                  <span className="material-symbols-outlined inspect-landing-fill">save</span>
                  {t('inspectLanding:artSaveEntry')}
                  <span className="inspect-landing-c7-tapring inspect-landing-c7-tap-c" />
                </div>
                <div className="inspect-landing-c7-saved">
                  <span className="material-symbols-outlined">check_circle</span>
                </div>
              </div>
            </div>
          </div>
          <div className="inspect-landing-c7-scan">
            <div className="inspect-landing-c7-scan-top">
              <span className="inspect-landing-c7-logo" />
              <span className="inspect-landing-c7-me" />
            </div>
            <div className="inspect-landing-c7-asset" />
            <div className="inspect-landing-c7-qr">
              <span className="material-symbols-outlined">qr_code_2</span>
            </div>
            <div className="inspect-landing-c7-frame">
              <span className="inspect-landing-c7-cn inspect-landing-c7-tl" />
              <span className="inspect-landing-c7-cn inspect-landing-c7-tr" />
              <span className="inspect-landing-c7-cn inspect-landing-c7-bl" />
              <span className="inspect-landing-c7-cn inspect-landing-c7-br" />
            </div>
            <span className="inspect-landing-c7-gohome">{t('inspectLanding:artGoHome')}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
